import Home from "./Home";
import Organizations from "./Organizations";
import Webhooks from "./Webhooks";
import Feeds from "./Feeds";
import Users from "./Users";
import Addresses from "./Addresses";
import Rules from "./Rules";

const routes = [
  ...Home,
  ...Organizations,
  ...Webhooks,
  ...Feeds,
  ...Users,
  ...Addresses,
  ...Rules,
];

export default routes;
